import React from 'react';
import { motion } from 'framer-motion';
const services = [{
  title: 'Portrait Sessions',
  description: 'Individual and senior portraits that capture your personality in beautiful settings — from the Shenandoah Valley to Washington, D.C.',
  image: 'https://cdn.magicpatterns.com/uploads/rhiWdFYgSZyuj2SQjc98FB/574083030_836586222223814_9173835478495803776_n.jpg'
}, {
  title: 'Families',
  description: "From newborns to growing families, I create relaxed, joyful sessions where everyone can be themselves. I'm especially comfortable with little ones.",
  image: 'https://cdn.magicpatterns.com/uploads/wDhnTUUkCTPyptCXVxaFro/573174977_18094296058813584_7879038735815211919_n.webp.jpg'
}, {
  title: 'Couples & Special Days',
  description: "Engagements, anniversaries, and all the special moments in between. Let's find the perfect spot—from the JMU Arboretum to local vineyards.",
  image: 'https://cdn.magicpatterns.com/uploads/5sjiQETaa7icZcAZsa4CsS/FullSizeRender_(8).jpg'
}];
export function Services() {
  return <section id="services" className="py-24 bg-cream" data-id="element-109">
      <div className="max-w-7xl mx-auto px-6" data-id="element-110">
        <div className="text-center mb-16" data-id="element-111">
          <span className="text-gold text-sm tracking-widest uppercase font-medium mb-4 block" data-id="element-112">
            Photography
          </span>
          <h2 className="font-serif text-4xl md:text-5xl text-charcoal" data-id="element-113">
            Services
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-114">
          {services.map((service, index) => <motion.div key={service.title} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="group bg-white p-4 shadow-sm hover:shadow-xl transition-shadow duration-300" data-id="element-115">
              <div className="overflow-hidden mb-6 aspect-[4/3]" data-id="element-116">
                <img src={service.image} alt={service.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-117" />
              </div>
              <div className="px-4 pb-8" data-id="element-118">
                <h3 className="font-serif text-2xl text-charcoal mb-3" data-id="element-119">
                  {service.title}
                </h3>
                <p className="text-charcoal/70 font-light leading-relaxed text-sm" data-id="element-120">
                  {service.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}